import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  container: {
    padding: '0 20px 16px 20px',
    background: '#FAFAFA',
    display: 'flex',
    gap: '34px',
  },
  input: {
    flex: '1 1 auto',
  },
  adornment: {
    color: '#9e9e9e',
  }
}))
